import React, { useEffect, useState } from "react"
import { verifyOtp, sendMobile as sendMobileNumber } from "../../store/actions"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Label,
  Alert,
  Spinner,
} from "reactstrap"

import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
const Otp = ({
  inputOTP,
  setInputOTP,
  phone_no,
  otpResponseMessage,
  verifyOTPLoading,
  sendOTPLoading,
  otpVerified,
  verifyOtpError,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = () => {
    setIsOpen(true)
    dispatch(sendMobileNumber({ phone_no: phone_no }))
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleSubmit = () => {
    //setIsOpen(false)
    dispatch(verifyOtp({ phone_no: phone_no, OTP: inputOTP }))
  }
  const sendOtp = () => {
    dispatch(sendMobileNumber({ phone_no: phone_no }))
  }
  useEffect(() => {
    otpResponseMessage === "OTP verified" ? handleClose() : ""
    toast.success(otpResponseMessage)
  }, [otpResponseMessage])
  return (
    <div>
      {otpVerified && otpResponseMessage === "OTP verified" ? (
        <Button color="success">OTP verified</Button>
      ) : (
        <Button color="primary" onClick={handleOpen}>
          Verify OTP
        </Button>
      )}

      <Modal isOpen={isOpen} toggle={handleClose}>
        <ModalHeader>
          <p>Verify Your OTP </p>
        </ModalHeader>
        {verifyOtpError ? <Alert color="danger">{verifyOtpError}</Alert> : ""}
        <ModalBody>
          <form>
            <FormGroup>
              <Label for="otpInput">OTP</Label>
              <Input
                type="text"
                id="otpInput"
                placeholder="Enter OTP"
                value={inputOTP}
                onChange={e => setInputOTP(e.target.value)}
              />
            </FormGroup>
            {verifyOTPLoading ? (
              <div display={"inline-block"} className="btn btn-primary">
                <Spinner size="sm" />
              </div>
            ) : (
              <>
               
                  <input
                    className="btn btn-primary ms-1"
                    type="button"
                    value={"Verify OTP"}
                    onClick={handleSubmit}
                  />
                
              </>
            )}
            &nbsp;&nbsp; or &nbsp;&nbsp;
            {sendOTPLoading ? (
              <div display={"inline-block"} className="btn btn-primary ms-1">
                <Spinner size="sm" />
              </div>
            ) : (
              <input
                className="btn btn-primary ms-1"
                type="button"
                value={"Resend Otp"}
                onClick={() => sendOtp()}
              />
            )}
          </form>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default Otp
